import React from 'react'
import * as S from './AirportTripSelector.styles';

import CustomRadioButton from '../../../../core-components/CustomRadioButtonUI/CustomRadioButtonUI';

export interface IAirportTripSelector {
    way: string;
    slug: string;
    reverseSlug: string;
}

export default function(props: IAirportTripSelector) {
    const { way = '', slug = '', reverseSlug = '' } = props;
    return (
        <S.AirportTripSelectorContainer>
            <S.AirportTripSelectorHeader>
                <S.AirportTripSelectorTitle>
                    Select Trip type
                </S.AirportTripSelectorTitle>
                <S.AirportTripSelectorSubTitle>
                    To update price, inlcuded kms & extra fare
                </S.AirportTripSelectorSubTitle>
            </S.AirportTripSelectorHeader>
            <S.AirportTripSelectorContent>
                <S.AirportTripSelector href={way === 'from' ? slug : reverseSlug}>
                    {way === 'from' ? <S.AirportTripSelectorActive>✓</S.AirportTripSelectorActive> : null}
                    <CustomRadioButton isActive={way === 'from'} />
                    <S.AirportTripSelectorTitle>Airport Pickup</S.AirportTripSelectorTitle>
                </S.AirportTripSelector>
                <S.AirportTripSelector href={way === 'to' ? slug : reverseSlug}>
                    {way === 'to' ? <S.AirportTripSelectorActive>✓</S.AirportTripSelectorActive> : null}
                    <CustomRadioButton isActive={way === 'to'} />
                    <S.AirportTripSelectorTitle>Airport Drop</S.AirportTripSelectorTitle>
                </S.AirportTripSelector>
            </S.AirportTripSelectorContent>
        </S.AirportTripSelectorContainer>
    )
}
